import { Note, NoteActivityType } from "@/models/Note";

export interface Consultation {
    id: number | null;
    patientId: number | string | undefined;
    storeId: number;
    storeName: string;
    status: number;
    statusName: string;
    clinical: boolean;
    requested: string;
    patientName: string;
    dateOfBirth: string;
    phoneNumber: string;
    cellNumber: string;
    created: Date;
    createdBy: string;
    closed: Date | null;
    closedBy: string;
    rxNumber?: number | null;
    type: ConsultationType;
    category: ConsultationCategory;
    completionQuestionSetId?: number;
    nextTouchDate: string | null;

    // The following are just a part of the view model
    drugName: string;
    note: string;
    questions: any[];
    answers: any[];
    notes: Note[];
    lastActivity: string | null;
    lastActivityType: NoteActivityType | null;
    programName: string;
    lockedBy?: string;
    lockExpires?: string;
}

export class Consultation {
    constructor(obj?: Consultation) {
        if (obj) {
            Object.assign(this, obj);

            if (obj.notes) {
                this.notes = obj.notes.map(n => new Note(n));
                if (!this.note || this.note.length === 0) {
                    const sortedNotes = this.notes?.filter(n => n.body?.trim().length > 0)
                                            .toSorted((a, b) => b.created.valueOf() - a.created.valueOf());
                    if (sortedNotes.length > 0) this.note = sortedNotes[0].body ?? "";
                }

            }

            if (obj.created) this.created = new Date(obj.created);
            if (obj.closed) this.closed = new Date(obj.closed);
            // Date-only value; keep as YYYY-MM-DD so no timezone conversion can shift the day.
            this.nextTouchDate = obj.nextTouchDate ? obj.nextTouchDate.substring(0, 10) : null;
        }
    }
}

export enum ConsultationType {
    General,
    DiseaseState,
    Drug,
    Adherence,
    Injection
}

export enum ConsultationCategory {
    RN,
    RPH
}

/**
 * Mirrors ConsultationStatus on the server, which is the authority. Unlike most status
 * enums in this codebase the values start at 1, so 0 is not a valid consultation status.
 */
export enum ConsultationStatus {
    New = 1,
    Open,
    Cancelled,
    Completed
}
